class InfiniteScroll {
    constructor() {
        this.options = {
            currentPage: "1",
            autoload: null,
            loadingClass: 'loading',
            containerSelector: '.container',
            actionsSelector: '.actions',
            paginationSelector: '.pagination',
            itemsContainerSelector: '.items',
            loadMoreButtonAttribute: 'data-infinite-scroll',
            infiniteScrollKey: "collection_page_cache",
            collectionPagination: ".collection__pagination",
        };
        this.sortSelects = document.querySelectorAll('[name="sort_by"]');

        this.registerEvents();
        this.loadFromSession();

        this.sortSelects.forEach(select => {
            select.addEventListener('change', () => {
                this.removeFromSession();
            });
        })
    }

    registerEvents() {
        this.init();

        document.addEventListener("product-grid-updated", () => {
            this.init();

            this.removeFromSession();
            this.saveToSession();
        });

        window.addEventListener("beforeunload", () => {
            const cachedContent = sessionStorage.getItem(
                this.options.infiniteScrollKey,
            );

            if (cachedContent) {
                const data = JSON.parse(cachedContent);


                data.scrollY = window.scrollY;
                sessionStorage.setItem(this.options.infiniteScrollKey, JSON.stringify(data));

                if (data.path !== window.location.pathname) {
                    this.removeFromSession();
                }
            }

        });

        window.addEventListener("pagehide", () => {
            const cacheRaw = sessionStorage.getItem(this.options.infiniteScrollKey);

            if (cacheRaw) {
                const data = JSON.parse(cacheRaw);
                data.scrollY = window.scrollY;
                sessionStorage.setItem(this.options.infiniteScrollKey, JSON.stringify(data));
            }
        });
    }

    init() {
        this.loadMoreButton = document.querySelector(`[${this.options.loadMoreButtonAttribute}]`);

        if (!this.loadMoreButton) return;

        const passedOptions = JSON.parse(this.loadMoreButton.getAttribute(this.options.loadMoreButtonAttribute) || {});
        this.options = {...this.options, ...passedOptions};

        this.actions = document.querySelector(this.options.actionsSelector);
        this.container = document.querySelector(this.options.containerSelector);
        this.pagination = document.querySelector(this.options.collectionPagination);
        this.itemsContainer = document.querySelector(this.options.itemsContainerSelector);

        const loadedButton = this.loadMoreButton.cloneNode(true);
        this.loadMoreButton.parentNode.replaceChild(loadedButton, this.loadMoreButton);
        this.loadMoreButton = loadedButton;
        this.loadMoreButton.addEventListener('click', () => this.load(this.pagination.dataset.page));

        if (this.options.autoload === 'true') {
            this.autoloadProducts();
        }
    }


    toggleLoader(state) {
        this.container.classList[state ? 'add' : 'remove'](this.options.loadingClass);
    }

    autoloadProducts() {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.load(this.pagination.dataset.page);
                }
            });
        }, {
            root: null,
            rootMargin: '0px',
            threshold: 0.1
        });

        observer.observe(this.loadMoreButton);
    }

    async load(currentPage) {
        const nextPageIterator = parseInt(currentPage, 10) + 1;
        const nextPageElement = this.pagination.querySelector(`a[href*="page=${nextPageIterator}"]`);

        if (!nextPageElement && !nextPageElement?.href) return;

        this.toggleLoader(true);

        await fetch(nextPageElement.href)
            .then(response => response.text())
            .then(response => {
                const html = new DOMParser().parseFromString(response, 'text/html');
                const updatedItems = html.querySelector(this.options.itemsContainerSelector);
                const updatedPagination = html.querySelector(this.options.paginationSelector);
                const updatedActions = html.querySelector(this.options.actionsSelector);

                [...updatedItems.children].forEach(article => this.itemsContainer.append(article));
                this.actions.innerHTML = updatedActions.innerHTML;
                this.pagination.parentElement.append(updatedPagination);
                this.pagination.remove();
                this.pagination = updatedPagination;
                this.toggleLoader(false);
                this.init();

                this.saveToSession();

                document.dispatchEvent(new CustomEvent("product-grid-updated"));
            })
            .catch(error => {
                console.error(error);
                this.toggleLoader(false);
            });
    }

    saveToSession() {

        const isLastPage = !this.pagination?.querySelector('a[href*="page="]');

        const data = {
            path: window.location.pathname,
            itemsHTML: this.itemsContainer.innerHTML,
            paginationHTML: isLastPage ? "" : this.pagination?.outerHTML || "",
        };

        sessionStorage.setItem(
            this.options.infiniteScrollKey,
            JSON.stringify(data),
        );
    }

    removeFromSession() {
        sessionStorage.removeItem(this.options.infiniteScrollKey);
    }

    loadFromSession() {

        const cached = sessionStorage.getItem(this.options.infiniteScrollKey);

        if (!cached) return;

        const {path, itemsHTML, paginationHTML, scrollY} = JSON.parse(cached);

        if (path === window.location.pathname) {
            const itemsContainer = document.querySelector(
                this.options.itemsContainerSelector,
            );
            const paginationContainer = document.querySelector(
                this.options.collectionPagination,
            );
            if (itemsContainer && itemsHTML) {
                itemsContainer.innerHTML = itemsHTML;
            }

            if (paginationContainer) {
                paginationContainer.innerHTML = "";

                if (paginationHTML) {
                    const wrapper = document.createElement("div");
                    wrapper.innerHTML = paginationHTML;

                    const newPagination = wrapper.firstElementChild;

                    if (newPagination) {
                        paginationContainer.replaceWith(newPagination);
                    }
                }
            }

            if (scrollY !== undefined) {
                window.scrollTo({top: scrollY, behavior: "auto"});
            }

            this.init();

            document.dispatchEvent(new CustomEvent("product-grid-updated"));
        }
    }
}

document.addEventListener('DOMContentLoaded', () => new InfiniteScroll());
